<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      v-if="!analysisCollection.length"
      xs12
      md6
      offset-md3
    >
      <v-card
        flat
        color="transparent"
      >
        <v-card-title class="title justify-center">
          <div>Getting started with Analysis</div>
        </v-card-title>

        <v-card-text class="text-justify">
          <p>
            Here you can analyze data from your entire organization,
            across projects, people, departments.
          </p>

          <div class="text-center">
            <v-btn
              depressed
              color="primary"
              @click="analysisCollection.add()"
            >
              <v-icon left>
                add
              </v-icon>
              {{ $t('create') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex
      xs12
      class="text-right"
    >
      <v-btn
        text
        color="primary"
        @click="addEmptyAnalysis()"
      >
        <v-icon left>
          add
        </v-icon>
        {{ $t('create') }}
      </v-btn>
    </v-flex>

    <v-flex
      v-for="analysis in analysisCollection.models"
      :key="`analysis-${analysis.id}`"
      xs12
    >
      <base-widget :analysis="analysis" />
    </v-flex>
  </v-layout>
</template>

<script>
import BaseWidget from '@/components/widgets/BaseWidget'
import AnalysisCollection from '@/models/AnalysisList'
import Analysis from '@/models/Analysis'

export default {
  components: {
    BaseWidget
  },
  data () {
    return {
      analysisCollection: new AnalysisCollection()
    }
  },
  mounted () {
    this.analysisCollection.fetch({
      organization: this.$currentOrganization.id
    })
  },
  methods: {
    addEmptyAnalysis () {
      this.analysisCollection.models.unshift(new Analysis())
    }
  }
}
</script>

<style lang="scss">
</style>
